module.exports = __webpack_public_path__ + "fonts/medium.966679d4.ttf";